exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".File-module__file___23AVn{background-color:#ececec;border-radius:7px;padding:1rem;display:grid;grid-template-columns:1fr auto;align-items:center;gap:1rem;font-weight:700}.File-module__file___23AVn.File-module__edit-mode___sx-c_{padding:0;height:100%}", ""]);

// exports
exports.locals = {
	"file": "File-module__file___23AVn",
	"edit-mode": "File-module__edit-mode___sx-c_"
};